export default "__VITE_ASSET__rmziJYx4__"